/**
 * 场景数据收集器
 */
export class SceneDataCollector {
    constructor() {
        this.sceneStartTime = Date.now();
    }
    /**
     * 收集场景数据
     * @param scene 场景实例
     */
    collectSceneData(scene) {
        if (!scene) {
            return {
                currentSceneName: 'No Scene',
                isInitialized: false,
                sceneRunTime: 0,
                sceneEntityCount: 0,
                sceneSystemCount: 0,
                sceneMemory: 0,
                sceneUptime: 0
            };
        }
        const currentTime = Date.now();
        const runTime = (currentTime - this.sceneStartTime) / 1000;
        const entityList = scene.entities;
        const entityProcessors = scene.entityProcessors;
        return {
            currentSceneName: scene.name || 'Unnamed Scene',
            isInitialized: scene._didSceneBegin || false,
            sceneRunTime: runTime,
            sceneEntityCount: entityList?.buffer?.length || 0,
            sceneSystemCount: entityProcessors?.processors?.length || 0,
            sceneMemory: 0, // TODO: 计算实际场景内存
            sceneUptime: runTime
        };
    }
    /**
     * 设置场景开始时间
     */
    setSceneStartTime(time) {
        this.sceneStartTime = time;
    }
}
//# sourceMappingURL=SceneDataCollector.js.map